import {Utils} from '../../common/scripts/utils';

class Cookie {
    constructor(duration) {
        this.cookie = document.querySelector('.j-cookie');
        this.messageShowDelay = 5000;
        this.cookieLength = 0;
        this.cookieOffset = -1;
        this.cookieDuration = duration || 1.5;
        this.activeClass = 'is-active';
    }

    init() {
        if (this._getCookie('cookie-accepted') !== null) {
            this._hideMessage();

            return;
        }

        this._showMessage();
        this._bindEvents();
    }

    _bindEvents() {
        const close = document.querySelector('.cookie__close');

        close.addEventListener('click', () => {
            this._hideMessage();
            this._setCookie('cookie-accepted', 'yes');
        });
    }

    _setCookie(name, value) {
        const date = new Date(new Date().getTime() + (this.cookieDuration * 86400000)).toUTCString();

        document.cookie = `${name}=${value}; path=/; expires=${date}`;
    }

    _getCookie(name) {
        const cookie = ` ${document.cookie}`;
        const search = ` ${name}=`;
        let setStr = null;
        let offset = 0;
        let end = 0;

        if (cookie.length > this.cookieLength) {
            offset = cookie.indexOf(search);
            if (offset !== this.cookieOffset) {
                offset = offset + search.length;
                end = cookie.indexOf(';', offset);
                if (end === this.cookieOffset) {
                    end = cookie.length;
                }
                setStr = unescape(cookie.substring(offset, end));
            }
        }

        return setStr;
    }

    _showMessage() {
        setTimeout(() => {
            this.cookie.classList.add(this.activeClass);
        }, this.messageShowDelay);
    }

    _hideMessage() {
        Utils.removeElement(this.cookie);
    }
}

export default Cookie;
